import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { Text } from 'components/core/Text';
import { Paragraph } from 'components/core/Paragraph';
import { Image } from 'components/core/Image';

import quotationMark from 'assets/images/icons/quotes.svg';

import './quote.scss';

/**
 * Styled quote component.
 */
export function Quote({
	className,
	quote,
	source
}) {
	return (
		<div className={classnames('ph-quote', className)}>
			<Image
				src={quotationMark}
				className="quotation-mark"
				alt="quatation Mark"
			/>
			<Paragraph size="small">
				<strong>{quote}</strong>
			</Paragraph>
			<Text size="tiny">
				&mdash; {source}
			</Text>
		</div>
	);
}

Quote.propTypes = {
	className: PropTypes.string,
	quote: PropTypes.string.isRequired,
	source: PropTypes.string.isRequired
};

export default Quote;
